
document.getElementById('pincodeForm').addEventListener('submit', function (event) {
    event.preventDefault();

    const pincode = document.getElementById('pincode').value;
    const pincodeInputElement = document.getElementById('pincode');
    const responseDiv = document.getElementById('response');
    const orderTimelineDiv = document.getElementById('order-timeline');
    const infoMessage = document.querySelector('.pincode-info-message');
    const deliverySvg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M13.332 2.5H0.832031V13.3333H13.332V2.5Z" stroke-width= 2px stroke="#A8875D" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.332 6.66699H16.6654L19.1654 9.16699V13.3337H13.332V6.66699Z" stroke-width= 2px stroke="#A8875D" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.58333 17.4997C5.73393 17.4997 6.66667 16.5669 6.66667 15.4163C6.66667 14.2657 5.73393 13.333 4.58333 13.333C3.43274 13.333 2.5 14.2657 2.5 15.4163C2.5 16.5669 3.43274 17.4997 4.58333 17.4997Z" stroke-width= 2px stroke="#A8875D" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M15.4154 17.4997C16.566 17.4997 17.4987 16.5669 17.4987 15.4163C17.4987 14.2657 16.566 13.333 15.4154 13.333C14.2648 13.333 13.332 14.2657 13.332 15.4163C13.332 16.5669 14.2648 17.4997 15.4154 17.4997Z" stroke-width= 2px stroke="#A8875D" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
    const errorSvg = ` <svg class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="2px"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"></circle><path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"></path><path fill="#fff" stroke="#EB001B" stroke-width=".7" d="M5.874 3.178h-.359l.01.359.1 4.044.008.341h1.736l.008-.341.1-4.044.01-.359H5.873Zm.627 6.833c.56 0 1.03-.432 1.03-1.006s-.47-1.006-1.03-1.006-1.031.432-1.031 1.006.47 1.006 1.03 1.006Z"></path></svg>`;

    const changePincodeButton = document.querySelector('.change-pincode-button');
    const submitPincodeButton = document.querySelector('.submit-pincode-button');
    const pincodeResponseContainer = document.querySelector('.pincode-response-container');

    const resetDisplayStyles = () => {
        submitPincodeButton.style.display = "block";
        changePincodeButton.style.display = "none";
        responseDiv.style.display = "none";
        infoMessage.style.display = "flex";
        orderTimelineDiv.style.display = "none";
        pincodeResponseContainer.style.display = "none";
    };

    responseDiv.style.display = "flex";
    infoMessage.style.display = "none";

    changePincodeButton.addEventListener("click", resetDisplayStyles);
    pincodeInputElement.addEventListener('keydown', resetDisplayStyles);

    // Clear previous response
    responseDiv.innerText = '';

    // Validate pincode
    if (!/^\d{6}$/.test(pincode)) {
        responseDiv.innerHTML = `${errorSvg} Please enter a valid pincode!`;
        responseDiv.style.display = 'flex';
        submitPincodeButton.style.display = "none";
        changePincodeButton.style.display = "block";
        pincodeResponseContainer.style.display = "block";
        return;
    }

    const url = 'https://lbp-edd.marmeto.com/api/estimate-delivery-days';
    const requestBody = { destination_pincode: pincode };

    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
    })
        .then(response => response.json())
        .then(data => {
            let message = '';
            if (data.success) {
                const now = new Date();
                const deliveryDate = new Date();
                const midnight = new Date();
                midnight.setHours(24, 0, 0, 0);

                const cutoff = new Date();
                if (now.getHours() >= 14) {
                    // After 2 PM — count down to tomorrow 2 PM
                    cutoff.setDate(cutoff.getDate() + 1);
                }
                cutoff.setHours(14, 0, 0, 0);

                const diffMs = cutoff - now;
                const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
                const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                const orderTime = `${diffHrs} hr${diffHrs !== 1 ? 's' : ''} and ${diffMins} min${diffMins !== 1 ? 's' : ''}`;

                // Add 1 extra day to ETA if current time is after 2 PM
                const extraDay = now.getHours() >= 14 ? 1 : 0;
                deliveryDate.setDate(deliveryDate.getDate() + data.data.data.tat + extraDay);

                const options = { weekday: 'short', month: 'long', day: 'numeric' };
                const formattedDate = deliveryDate.toLocaleDateString('en-US', options);

                message = `${deliverySvg} Get it by ${formattedDate}`;

                orderTimelineDiv.innerHTML = `If ordered within <strong>${orderTime}</strong>`;
                orderTimelineDiv.style.display = "block";
                infoMessage.style.display = "none";
                submitPincodeButton.style.display = "none";
                changePincodeButton.style.display = "block";
                responseDiv.style.display = "flex";
                pincodeResponseContainer.style.display = "block";
            } else {
                message = `${errorSvg} ${data.message}!`;
                infoMessage.style.display = "none";
                submitPincodeButton.style.display = "none";
                changePincodeButton.style.display = "block";
                responseDiv.style.display = "flex";
                pincodeResponseContainer.style.display = "block";
            }
            responseDiv.innerHTML = message;
        })
        .catch(error => {
            responseDiv.innerText = `Error: Unable to fetch data. ${error}`;
        });
});